import { ReactElement } from 'react';
import { ReactComponent as Cross } from 'src/assets/cross.svg';
import { ReactComponent as Warning } from 'src/assets/warning.svg';

interface BottomSheetTypes {
  sheetTitle?: string | ReactElement;
  sheetData: any;
  focusHome: Function;
  footer?: ReactElement;
  width?: string;
  isMinHightExist?: boolean;
  bgScrimNotAllowed?: boolean;
  isDefaultMinHeight?: boolean;
  scrimClassName?: string;
  bodyClassName?: string;
  customClass?: string;
  isFooterPositionFixed?: boolean;
  marginTop?: string
}

export const BottomSheet = ({
  focusHome,
  bgScrimNotAllowed,
  footer,
  sheetTitle,
  sheetData,
  isMinHightExist,
  isDefaultMinHeight,
  scrimClassName = '',
  bodyClassName = '',
  customClass = '',
  isFooterPositionFixed = false,
  marginTop = '70px',
}: BottomSheetTypes): ReactElement => {
  const bodyMarginStyle = sheetTitle ? { marginTop: marginTop } : {};
  return (
    <div className="h-full">
      <div
        onClick={(): void => focusHome()}
        className={`${scrimClassName} ${customClass} h-full z-10 top-0 fixed phone:w-2/5 w-full ${
          bgScrimNotAllowed ? '' : 'bg-scrim'
        } opacity-30`}
      />

      <div
        id="bottomSheet"
        className={`${bodyClassName} ${customClass} fixed overscroll-contain shadow-tab z-20 bottom-0 max-h-[80%] h-fit overflow-auto scrollbar-hide rounded-t-xl w-full phone:w-2/5 bg-white ${
          isMinHightExist
            ? 'min-h-fit'
            : isDefaultMinHeight
              ? 'min-h-[320px]'
              : 'min-h-[80dvh]'
        }`}>
        <div className="mx-auto absolute w-[40px] h-[4px] mt-3 bg-[#E5E5E5] left-0 right-0 rounded"></div>
        <div className="top-4 flex">
          {sheetTitle && (
            <>
              <div className="mt-[30px] absolute left-6 top-0 text-base font-bold text-label">
                {sheetTitle}
              </div>
              <div
                onClick={(): void => focusHome()}
                className="cursor-pointer mt-[30px] right-6 absolute">
                <Cross />
              </div>
            </>
          )}
        </div>
        <div
          style={bodyMarginStyle} 
          className="overflow-auto max-h-[80dvh] scrollbar-hide"
        >
          {sheetData}
        </div>
        {footer && (
          <div
            className={`${
              isFooterPositionFixed ? 'fixed w-full phone:w-2/5' : 'absolute w-full'
            } bottom-0`}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

interface FinishedFabricQualityContainerTypes {
  sheetData: ReactElement;
  title: string;
}

export const FinishedFabricQualityContainer = (
  props: FinishedFabricQualityContainerTypes,
): ReactElement => {
  return (
    <div className="bg-quotes">
      <div className="pt-6 pl-6 pb-6 text-sm font-normal text-label">
        {props.title && props.title} Fabric Quality
      </div>
      {props.sheetData}
    </div>
  );
};

export const BottomSheetNotification = (): ReactElement => {
  return (
    <div className="h-warningNotification bg-warningNotification flex">
      <div className="pt-[18px] ml-[26px]">
        <Warning />
      </div>
      <div className=" mx-2 pt-[18px] text-sm font-normal">
        Please reach out to your relationship manager for any change in the fabric details.
      </div>
    </div>
  );
};
